import api from '@/lib/api';
import type {
  PaginatedResponse,
  Promotion,
  PromotionDiscountType,
} from '@pms/shared';

// ─── Query / payload types ────────────────────────────────────────────────────

export interface ListPromotionsQuery {
  propertyId: string;
  search?: string | undefined;
  isActive?: boolean | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export interface CreatePromotionPayload {
  propertyId: string;
  code: string;
  description?: string | undefined;
  discountType: PromotionDiscountType;
  value: number;
  validFrom: string;
  validTo: string;
  minNights?: number | undefined;
  minSpend?: number | undefined;
  maxRedemptions?: number | undefined;
  isActive?: boolean | undefined;
}

export interface UpdatePromotionPayload {
  code?: string | undefined;
  description?: string | undefined;
  discountType?: PromotionDiscountType | undefined;
  value?: number | undefined;
  validFrom?: string | undefined;
  validTo?: string | undefined;
  minNights?: number | undefined;
  minSpend?: number | undefined;
  maxRedemptions?: number | undefined;
  isActive?: boolean | undefined;
}

// ─── API functions ────────────────────────────────────────────────────────────

export async function fetchPromotions(
  query: ListPromotionsQuery,
): Promise<PaginatedResponse<Promotion>> {
  const { data } = await api.get<PaginatedResponse<Promotion>>('/promotions', {
    params: query,
  });
  return data;
}

export async function createPromotion(
  payload: CreatePromotionPayload,
): Promise<Promotion> {
  const { data } = await api.post<Promotion>('/promotions', payload);
  return data;
}

export async function updatePromotion(
  id: string,
  payload: UpdatePromotionPayload,
): Promise<Promotion> {
  const { data } = await api.patch<Promotion>(`/promotions/${id}`, payload);
  return data;
}

export async function deletePromotion(id: string): Promise<void> {
  await api.delete(`/promotions/${id}`);
}
